import { createAction } from 'redux-actions'
import pickBy from 'lodash.pickby'
import {some,includes} from 'lodash'

export const setDownloadsDataAction = createAction('SET_DOWNLOADS_DATA')

  export const setDownloadsData = (translations,injection) => {
    return dispatch => {
      var downloads_parsed = [];
      var downloads_elements = pickBy(translations, (_value, key) => key.startsWith('download'))
      var downloads_ids = [...new Set((Object.keys(downloads_elements).map( function (value) {
        if (!isNaN(parseInt(value.split('.')[2]))){
          return parseInt(value.split('.')[2])
        } else {
          return "string"
        }
      })))]
      downloads_ids =  downloads_ids.filter(value => value !== "string")

      downloads_ids.forEach(function (index) {
        var downloads_elements_2 = pickBy(downloads_elements, (_value, key) => (key.indexOf("."+index+".label") !== -1) )
        downloads_parsed[index] = Object.keys(downloads_elements_2).map( function (value) {
            if (value.indexOf("."+index+".label") !== -1) {
                if (value.split("."+index+".label.")[1] == undefined) {
                  return {"link_groups":''}
                } else {
                  if (value.indexOf("all") !== -1) {
                    return {"link_all":value.split("."+index+".label.")[1]}
                  } else if (value.indexOf("metodologia") !== -1) {
                    return {"link_metodologia":value.split("."+index+".label.")[1]}
                  } else {
                    return {"link_groups":value.split("."+index+".label.")[1]}
                  }
                }
            }
          })
      }.bind(downloads_elements))
      var links = new Array();
      var downloads = []
      downloads_parsed.forEach(function (value,index) {
        value.forEach(function (object) {
            if (!links[index]) {
              links[index] = [index];
            }
            if (object.link_all !== undefined) {
              if (!links[index]['link_all']) {
                links[index]['link_all'] = [object.link_all];
              } else {
                links[index]['link_all'].push(object.link_all)
              }
            }
            if (object.link_groups !== undefined) {
              if (!links[index]['link_groups']) {
                links[index]['link_groups'] = [object.link_groups];
              } else {
                links[index]['link_groups'].push(object.link_groups)
              }
            }
            if (object.link_metodologia !== undefined) {
              if (!links[index]['link_metodologia']) {
                links[index]['link_metodologia'] = [object.link_metodologia];
              } else {
                links[index]['link_metodologia'].push(object.link_metodologia)
              }
            }
        }.bind(index))
      })
      var downloads = links.filter(function (el) {
        return el != null;
      });      
    
      dispatch(setDownloadsDataAction(downloads))
    }
  
  }


// WEBPACK FOOTER //
// ./src/actions/downloads.js